import { render, staticRenderFns } from "./EditPersonTabBank.vue?vue&type=template&id=47e59954&scoped=true&"
import script from "./EditPersonTabBank.vue?vue&type=script&lang=js&"
export * from "./EditPersonTabBank.vue?vue&type=script&lang=js&"
import style0 from "./EditPersonTabBank.vue?vue&type=style&index=0&id=47e59954&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47e59954",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VForm } from 'vuetify/lib/components/VForm';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VContainer,VForm,VRow})
